import {color} from 'csx';

const fadedColor = (col: string, opacity: number) =>
    color(col)
        .fade(opacity)
        .toString();

// Base colors

export const BlackColor = '#000';
export const WhiteColor = '#FFF';

export const WarningColor = '#FFA500';
export const ErrorColor = '#F00';

export const Chart0Color = '#1F77B4';
export const Chart1Color = '#FF7F0E';
export const Chart2Color = '#E45756';
export const Chart3Color = '#72B7B2';
export const Chart4Color = '#9467BD';
export const Chart5Color = '#8C564B';
export const Chart6Color = '#E377C2';
export const Chart7Color = '#7F7F7F';
export const Chart8Color = '#BCBD22';
export const Chart9Color = '#17BECF';

export const CiBlueGradientColor = '#4A5C98';
export const CiBlueColor = '#000073';

export const LightBlueBackgroundColor = '#E5EDFF';
export const GreyBlueBackgroundColor = '#D1D9E6';
export const BlueBackgroundColor = '#C8EBFF';

export const LightBlueColor = '#99DAFF';
export const BlueColor = '#3498DB';
export const RedColor = '#B7183D';
export const GreenColor = '#080';

export const TableRowBackgroundColor = '#F2F2F2';

export const LightGreyColor = '#DDD';
export const GreyColor = '#888';
export const DarkGreyColor = '#666';

// Special need colors

export const ChartableCellWithContextMenuColor = '#A94AF7';
export const InsightCopySuccessButtonColor = '#9ACD32';
export const DateSelectorColor = '#00A699';
export const DashboardKpiHoverColor = GreenColor;
export const TableCellRateColor = '#67D085';

// Faded colors (try to reuse!)

export const BlackColorFaded05 = fadedColor(BlackColor, 0.05);
export const BlackColorFaded10 = fadedColor(BlackColor, 0.1);
export const BlackColorFaded20 = fadedColor(BlackColor, 0.2);
export const BlackColorFaded30 = fadedColor(BlackColor, 0.3);
export const BlackColorFaded40 = fadedColor(BlackColor, 0.4);
export const BlackColorFaded50 = fadedColor(BlackColor, 0.5);
export const WhiteColorFaded10 = fadedColor(WhiteColor, 0.1);
export const WhiteColorFaded20 = fadedColor(WhiteColor, 0.2);
export const WhiteColorFaded70 = fadedColor(WhiteColor, 0.7);
export const WhiteColorFaded80 = fadedColor(WhiteColor, 0.8);
export const WhiteColorFaded90 = fadedColor(WhiteColor, 0.9);
export const BlueColorFaded20 = fadedColor(BlueColor, 0.2);
export const BlueColorFaded40 = fadedColor(BlueColor, 0.4);
export const ErrorColorFaded20 = fadedColor(ErrorColor, 0.2);
export const ErrorColorFaded60 = fadedColor(ErrorColor, 0.6);
export const GreenColorFaded20 = fadedColor(GreenColor, 0.2);
export const TableCellRateColor50 = fadedColor(TableCellRateColor, 0.5);
export const TableCellRateColor80 = fadedColor(TableCellRateColor, 0.8);

// Shadows (try to reuse!)

export const Shadow1 = '0px 1px 3px 0px rgba(0, 0, 0, 0.2), 0px 1px 1px 0px rgba(0, 0, 0, 0.14), 0px 2px 1px -1px rgba(0, 0, 0, 0.12)';
export const BlueShadow1 = '0px 1px 3px 0px rgba(0, 0, 255, 0.2), 0px 1px 1px 0px rgba(0, 0, 255, 0.14), 0px 2px 1px -1px rgba(0, 0, 255, 0.12)';
export const Shadow2 = '0 10px 20px rgba(0,0,0,0.19), 0 6px 6px rgba(0,0,0,0.23)';
export const Shadow5 = 'inset 0 0 20px rgba(0,0,0,.5)';
export const Shadow6 = 'inset 0 0 2px rgba(0,0,0,.2)';
export const Shadow8 = '0 0 3px rgba(0,0,0,.5)';
export const Shadow9 = '0 0 10px rgba(0,0,0,0.5)';



// WEBPACK FOOTER //
// ./src/styles/colors.ts